import React from 'react';

/**
 * The "💡 why this was picked" line shown under each AI pick tile.
 * Presentational. `loading` renders a shimmer so the tile (poster) can appear
 * before the snippet loads. `tone` adapts the text colour to the panel theme.
 */
const AISnippet = ({ why, loading = false, tone = 'light' }) => {
  const dark = tone === 'dark';
  if (loading) {
    return (
      <div className="mt-2 space-y-1.5" aria-hidden="true">
        <div className={`h-2.5 rounded animate-pulse w-full ${dark ? 'bg-white/10' : 'bg-purple-200/60'}`} />
        <div className={`h-2.5 rounded animate-pulse w-4/5 ${dark ? 'bg-white/10' : 'bg-purple-200/60'}`} />
      </div>
    );
  }
  if (!why) return null;
  return (
    <div className="mt-2 flex items-start gap-1.5 text-left">
      <span className="text-sm leading-none mt-0.5">💡</span>
      <p className={`text-xs leading-snug ${dark ? 'text-zinc-300' : 'text-purple-900/90'}`}>{why}</p>
    </div>
  );
};

export default AISnippet;
